module.exports = __webpack_public_path__ + "static/media/toilet.2ab482cd.png";